export var queryUpdateItem = function queryUpdateItem(type, id, request, response) {
  if (id) {
    return {
      query: "\n        mutation {\n          ".concat(type, "(wid: \"").concat(id, "\" items: ").concat(JSON.stringify(request).replace(/"([^(")"]+)":/g, '$1:'), "){\n            ").concat(response, "\n          }\n        }")
    };
  }

  return {
    query: "\n      mutation {\n        ".concat(type, "(items: ").concat(JSON.stringify(request).replace(/"([^(")"]+)":/g, '$1:'), "){\n          ").concat(response, "\n        }\n      }")
  };
};
export var queryGetWishlistPartNumbers = {
  query: "{\n    wishlists {\n      id:wid\n      name\n      primary\n      items {\n        partNumber\n      }\n    }\n  }"
};